import { render, staticRenderFns } from "./MoreLessControl.vue?vue&type=template&id=ba91be9c&"
import script from "./MoreLessControl.vue?vue&type=script&lang=js&"
export * from "./MoreLessControl.vue?vue&type=script&lang=js&"
import style0 from "./MoreLessControl.vue?vue&type=style&index=0&id=ba91be9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports